<script>
    export let title
    export let items  = []
    export let edit   = false
    export let onEdit = () => false

    function update(item) {
        return () => {
            onEdit(item)
        }
    }
</script>
<style>
    .content .header, .vlist h6 {
        font-weight: 700;
    }

    .vlist > div {
        color: #bababa;
    }

    .content .header {
        font-size: 1.2em;
        margin-bottom: 1em;
    }
    
    .vlist {
        margin-bottom: .5em;
    }
    
    .vlist div {
        overflow: hidden;
        text-overflow: ellipsis;        
    }

    .vlist h6 {
        font-size: 1em;
        border: 0 !important;    
    }
    a {
        margin-right: 1em;
    }
</style>
<div class="ui basic segment">
    <div class="content">
        <div class="header">{title}</div>
        <div class="description">
            {#each items as item}
                <div class="vlist">
                    <h6> { item.key }</h6>
                    <div>
                        {#if item.value }
                        {#if edit} <a href="#" on:click|preventDefault={update(item)}>retificar</a>{/if} { item.value }
                        {:else}
                            <div class="ui red horizontal small label">ausente</div>
                        {/if}
                    </div>
                </div>
            {/each}
        </div>
    </div>                
</div>